import {Component, OnInit} from '@angular/core';
import { AppService } from '../../App/app.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { NgZone } from '@angular/core';
import { MessageService } from '../message.service';

@Component({
  selector: 'app-question-header',
  templateUrl: './question-header.component.html',
  styleUrls: ['./question-header.component.css']
})
export class QuestionHeaderComponent implements OnInit {

  id: number;

  generatable: boolean;
  showExerciseTip = true;

  constructor(public appService: AppService, protected _location: Location, public messageService: MessageService
              , protected router: Router, protected activedRoute: ActivatedRoute) { }

  ngOnInit() {
    console.log(this.id);
    this.id = this.appService.currentTeacherExercise.id;
    this.generatable = (typeof this.appService.currentTeacherExercise.generate === 'function');
    console.log(this.id);
  }

  /** action to call, when a backlink was clicked */
  backClicked() {
    this._location.back();
  }

  /** get text in right language
 * @param {string} tag - text to load
 */
  get(tag: string): string {
    return this.appService.get(tag);
  }

  /** adds the current configuration to the global configuration */
  add() {
    this.appService.currentTeacherExercise.add();
    console.log(this.id);
    this.id = this.appService.currentTeacherExercise.id;
    this.messageService.addAlertWithTimeout(this.get('exerciseAdded'), 'success', 10000);

  }

  /** updates the configuration */
  update() {
    this.appService.currentTeacherExercise.update();
    this.messageService.addAlertWithTimeout(this.get('exerciseUpdated'), 'success', 10000);
  }

  /** route to the students view of the exercise */
  view() {
    this.router.navigateByUrl('/'.concat(this.appService.currentTeacherExercise.chapterType(), '/'
      , this.appService.currentTeacherExercise.type, '/' , this.appService.currentTeacherExercise.id.toString() )
      , {relativeTo: this.activedRoute});
  }

  /** calls the current teacher exercise to generate */
  generate() {
    this.appService.currentTeacherExercise.generate();
  }

  /** calls the current teacher exercise to reset */
  reset() {
    this.appService.currentTeacherExercise.reset();
    this.id = undefined;
  }
}
